package ru.ontando.auth.web.network

import ru.ontando.auth.web.ClientContext
import ru.ontando.auth.web.ClientState

class ServiceProvider(context: ClientContext) {

    val authService = AuthService(context)

}